import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCoolingTowerDryForcedDraught = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 120,
	viewBox: "0 0 100.0 120.0",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M 0.0 120.0 L 0.0 100.0 L 25.0 0.0 L 75.0 0.0 L 100.0 100.0 L 100.0 120.0 Z",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 100.0 100.0 L 0.0 100.0 M 0.0 110.0 L 100.0 110.0 M 50.0 105.0 L 50.0 115.0 M 37.5 105.0 L 37.5 115.0 M 25.0 105.0 L 25.0 115.0 M 12.5 105.0 L 12.5 115.0 M 62.5 105.0 L 62.5 115.0 M 75.0 105.0 L 75.0 115.0 M 87.5 105.0 L 87.5 115.0 M 42.0 62.5 L 36.0 81.0 M 58.0 62.5 L 64.0 81.0",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 50,
			cy: 75,
			rx: 15,
			ry: 15,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgCoolingTowerDryForcedDraught;
